import { memo, useState, useCallback } from 'react';
import { useCooperativeId } from 'hooks';
import services from 'services';

import { Modal } from 'components';
import ConfirmationDialogDetails from 'components/widgets/welcome-widget/confirmation-dialog-details';

interface Props {
  handleClose: (flag?: boolean) => void;
}

const ConfirmationDialog = ({ handleClose }: Props) => {
  const coopId = useCooperativeId();
  const [upload, setUpload] = useState(false);

  const dontShowWidgetNextTime = useCallback(async () => {
    try {
      setUpload(true);

      await services.put(`/api/user/cooperatives/${coopId}/overview/settings`, {
        ShowWelcomeWidget: false,
      });

      handleClose(true);
    } catch (err) {
      console.error(err);

      setUpload(false);
    }
  }, [coopId]);

  const handleReject = () => {
    handleClose(true);
  };

  const handleCloseConfirmationDialog = () => {
    handleClose();
  };

  return (
    <Modal
      open
      handleClose={upload ? undefined : handleCloseConfirmationDialog}
      maxWidth="xs"
      fullWidth
      disableBackdropClick={true}
    >
      <ConfirmationDialogDetails
        upload={upload}
        apply={dontShowWidgetNextTime}
        reject={handleReject}
      />
    </Modal>
  );
};

export default memo(ConfirmationDialog);
